__webpack_require__.p = "https://d3cuyjequulw.cloudfront.net/patient-app/sandbox/master/";